/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_AttendedInputs */

const cs_enum_attended = /** @type {(inputs: Enum_AttendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Účast`)
};

const en_enum_attended = /** @type {(inputs: Enum_AttendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attended`)
};

/**
* | output |
* | --- |
* | "Attended" |
*
* @param {Enum_AttendedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_attended = /** @type {((inputs?: Enum_AttendedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_AttendedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_attended(inputs)
	return cs_enum_attended(inputs)
});